import { Doughnut } from "react-chartjs-2";
import { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";

Chart.register(CategoryScale);

const COLORS = ["#1a73e8", "#00acc1", "#9e9e9e", "#2e7d32", "#e53935"];
const COLORS_HOVER = ["#1557b0", "#00838f", "#757575", "#1b5e20", "#b71c1c"];

const percentageLabelsPlugin = {
  id: "percentageLabels",
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    if (!meta?.data?.length) return;

    const dataset = chart.data.datasets[0];
    const total = dataset.data.reduce((sum, v) => sum + (parseFloat(v) || 0), 0);
    if (!total) return;

    meta.data.forEach((arc, i) => {
      const value = parseFloat(dataset.data[i]) || 0;
      const pct = (value / total) * 100;
      if (pct < 5) return; // skip slices too small to label

      const { x, y } = arc.getCenterPoint();
      ctx.save();
      ctx.fillStyle = "#fff";
      ctx.font = "bold 12px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.shadowColor = "rgba(0,0,0,0.25)";
      ctx.shadowBlur = 3;
      ctx.fillText(Math.round(pct) + "%", x, y);
      ctx.restore();
    });
  },
};

const PieChart = ({ Data = [] }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    setChartData({
      labels: Data.map((d) => d.label),
      datasets: [
        {
          data: Data.map((d) => d.number),
          backgroundColor: COLORS,
          hoverBackgroundColor: COLORS_HOVER,
          borderColor: "#fff",
          borderWidth: 3,
          hoverOffset: 8,
        },
      ],
    });
  }, [Data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "62%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#616161",
          font: { size: 12 },
          padding: 20,
          boxWidth: 12,
          boxHeight: 12,
          borderRadius: 4,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        backgroundColor: "#1e293b",
        titleColor: "#f1f5f9",
        bodyColor: "#94a3b8",
        borderColor: "transparent",
        borderWidth: 0,
        padding: 12,
        cornerRadius: 10,
        displayColors: true,
        boxWidth: 8,
        boxHeight: 8,
        callbacks: {
          label: (ctx) => {
            const total = ctx.dataset.data.reduce((a, b) => a + (parseFloat(b) || 0), 0);
            const pct = total ? ((ctx.parsed / total) * 100).toFixed(1) : 0;
            return ` ${ctx.label}: ${ctx.parsed} (${pct}%)`;
          },
        },
      },
    },
  };

  return chartData ? (
    <div style={{ position: "relative", height: "320px" }}>
      <Doughnut data={chartData} options={options} plugins={[percentageLabelsPlugin]} />
    </div>
  ) : null;
};

export default PieChart;
